import Aos from "aos";
import { useEffect } from "react";


const SolarFinancingPartners = () => {

    const partnersData = [
        { src: `${process.env.PUBLIC_URL}/assets/img/fixr.svg`, alt: "Fixr" },
        { src: `${process.env.PUBLIC_URL}/assets/img/cornerstone.svg`, alt: "Cornerstone Solar" },
        { src: `${process.env.PUBLIC_URL}/assets/img/bainsbridge.svg`, alt: "Powered by Bainsbridge" },
        { src: `${process.env.PUBLIC_URL}/assets/img/afriipower.svg`, alt: "Afriipower" },
        { src: `${process.env.PUBLIC_URL}/assets/img/ashdam.svg`, alt: "Ashdam Solar" },
        { src: `${process.env.PUBLIC_URL}/assets/img/benterry.svg`, alt: "Benterry Concept" }
    ];

    useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);

    return (
        <section className="partners-section" data-aos="fade-up" data-aos-duration="1000">
            <h2 className="partners-heading" data-aos="fade-down" data-aos-delay="200">
                Our Partners
            </h2>

            <div className="partners-grid">
                {partnersData.map((logo, index) => (
                    <div
                        key={index}
                        className="partner-logo-wrapper"
                        data-aos="zoom-in"
                        data-aos-delay={300 + index * 100} // Clean staggered fade-in visual entry
                    >
                        <img src={logo.src} alt={logo.alt} className="partner-logo-img" />
                    </div>
                ))}
            </div>
        </section>
    );
}

export default SolarFinancingPartners;